import(/* webpackMode: "eager" */ "/app/app/[lng]/api/auth/login/page.tsx");
